// extracted by mini-css-extract-plugin
export default {"main":"UpdateNews_main__ysK8z","topMain":"UpdateNews_topMain__TxRaP","topMainTitle":"UpdateNews_topMainTitle__0Xg7m","bodyMain":"UpdateNews_bodyMain__Aigyd"};